class DeliveryRegionRoutingAllController {
    /*@ngInject*/

    constructor(User, $state, $stateParams, CommonLayoutService, RegionRoutingService, $scope, SetupService, Modal) {
        this.User = User;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.RegionRoutingService = RegionRoutingService;
        this.CommonLayoutService = CommonLayoutService;
        this.SetupService = SetupService;
        this.hasAcl = {};
        this.$scope = $scope;
        this.Modal = Modal;

        this.model = {
            branch: User.getUser().branchId,
            loggedInUser: User.getUser(),
            regionRouting: false,
            weekDays: CommonLayoutService.getWeekDays(),
            selectedDay: 'Sun',
            bucketObj: {},
            regionsObj: {}
        }
        this.map = '';
    }

    $onInit() {
        let pageId = this.$stateParams.page;
        if (pageId > 0) {
            this.page = pageId;
        }
        /* this.SetupService.get(this.model.branch)
            .then((data) => {
                this.loadMap();
                this.branchDetails(data);
                this.getAllLocations();
            })
            .catch((err) => {
                this.Modal.errorModal('error.' + err.data.message);
            }) */
    }

    edit(obj) {
        this.$state.go('delivery-region-routing.edit', ({
            id: obj.id
        }))
    }

    selectDay(day) {
        this.model.selectedDay = day.value;
    }

    getAllLocations() {
        // this.model.bucketObj[title].process = true;

        this.RegionRoutingService.getAllLocations(10, 0)
            .then((data) => {
                // this.model.bucketObj[title].details = data;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                // this.model.bucketObj[title].process = false;
            })
    }


    getLocations(title) {
        this.model.bucketObj[title].process = true;

        this.RegionRoutingService.getLocations(title, this.model.regionsObj[title].latDetails, this.model.regionsObj[title].longDetails,
            this.model.bucketObj[title].pagination.pageLimit, (this.model.bucketObj[title].pagination.page - 1) * this.model.bucketObj[title].pagination.pageLimit)
            .then((data) => {
                this.model.bucketObj[title].details = data;
            })
            .catch((err) => {
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal(err.data.message);
                }
            })
            .finally(() => {
                this.model.bucketObj[title].process = false;
            })
    }

    findMinMaxLat(array) { // TODO: better solution for this
        let lowest = Number.POSITIVE_INFINITY;
        let highest = Number.NEGATIVE_INFINITY;
        for (let i = array.length - 1; i >= 0; i--) {
            let tmp = array[i].lat;
            if (tmp < lowest) lowest = tmp;
            if (tmp > highest) highest = tmp;
        }
        return { lowest, highest };
    }

    findMinMaxLong(array) { // TODO: better solution for this
        let lowest = Number.NEGATIVE_INFINITY;
        let highest;
        for (let i = array.length - 1; i >= 0; i--) {
            let tmp = array[i].lng;
            if (tmp > lowest) highest = tmp;
        }
        lowest = _.min(array, 'lng');
        return { lowest: highest, highest: lowest.lng };
    }

    
};

export default DeliveryRegionRoutingAllController;


// WEBPACK FOOTER //
// ./client/app/components/delivery_region_routing/all/delivery_region_routing.all.controller.js